import { Component, h } from "preact";

import { Icon } from "../../Icon";

export function PlusIcon(rest) {
  return (
    <Icon {...rest}>
      <path d="M0 23.3333H50V26.6666H0V23.3333Z" />
      <path d="M26.667 1.82131e-07L26.667 50H23.3337L23.3337 0L26.667 1.82131e-07Z" />
    </Icon>
  );
}
